"use client";
import MainLayout from "@/components/layout/mainLayout";
import Image from "next/image";
import Image500 from "@/public/images/500.svg";
import { Button } from "@/components/ui/button";


export default function Error({ error, reset } : any) {

    console.log({ message: error.message, stack: error.stack, name: error.name })

    return (
        <MainLayout>
            <section className="w-full translate-y-[-20px] flex flex-wrap justify-center items-center">
                <Image src={Image500} alt="50s0" />
                <div className="w-full flex flex-wrap text-center h-[161px] translate-y-[-50px] lg:translate-y-[-80px]">
                    <div className="w-full">
                        <div className="text-[18px] md:text-[24px] [font-weight:700] pb-3">
                            صفحه ی مورد نظر یافت نشد
                        </div>
                        <div className="text-base md:text-[20px] [font-weight:500]">
                            در حال حاضر وب سایت به دلیل استقبال زیاد، خارج از دسترس می باشد. دوباره امتحان کنید.
                        </div>
                    </div>
                    <div className="w-full">
                        <Button
                            onClick={() => (window.location.href = "/")}
                            className="text-[14px] w-[344px] md:w-[245px] h-[48px] rounded-2xl mt-3 bg-orange-primary active:scale-95 transition-all duration-200"
                        >
                            بازگشت به صفحه اصلی
                        </Button>
                    </div>
                </div>
            </section>
        </MainLayout>
    );
}